import { IconComponentStyled } from '@procurify/ui'
import styled from 'styled-components'

export const CommandInputWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.space.small};
  width: 100%;
  height: ${(props) => props.theme.typography.pxToRem(56)};

  > ${IconComponentStyled} {
    padding: ${(props) => props.theme.space.xsmall};
  }
`
